module.exports = __webpack_public_path__ + "img/pageType1.9a559299.png";